// Auto-generated enum file
// Generated by model:types command

export enum SettingType {
  AUDIO = 1,
  AVATAR = 2,
  BADGE = 3,
  BOOLEAN = 4,
  BOOLEAN_GROUP = 5,
  CODE = 6,
  COLOUR = 7,
  COUNTRY = 8,
  CURRENCY = 9,
  DATE = 10,
  DATETIME = 11,
  EMAIL = 12,
  FILE = 13,
  GRAVATAR = 14,
  HEADING = 15,
  HIDDEN = 16,
  ID = 17,
  IMAGE = 18,
  IMGIX_IMAGE = 19,
  KEY_VALUE = 20,
  MARKDOWN = 21,
  MULTISELECT = 22,
  NUMBER = 23,
  PASSWORD = 24,
  PASSWORD_CONFIRMATION = 25,
  SELECT = 26,
  SLUG = 27,
  SPARKLINE = 28,
  STATUS = 29,
  STACK = 30,
  TAG = 31,
  TEXT = 32,
  TEXTAREA = 33,
  TIMEZONE = 34,
  TRIX = 35,
  UI_AVATAR = 36,
  URL = 37,
  VAPOR_FILE = 38,
  VAPOR_IMAGE = 39,
  FONTAWESOME_ICON = 40,
}
